import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../constants/url";
import styled from "styled-components";
import { jwtDecode } from "jwt-decode";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  flex-direction: column;
  gap: 1rem;
`;

const Loader = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Message = styled.div`
  font-size: 1.2rem;
  color: #333;
`;

const TestPayment = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const validateAndInitiatePayment = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const userToken = params.get("userToken");
        const amount = params.get("amount");
        const orderId = params.get("order_id");
        const memberCode = params.get("memberCode");
        const memberId = params.get("memberId");
        const userData = jwtDecode(userToken);

        if (!userToken || !amount || !orderId) {
          throw new Error("Missing required parameters");
        }
        
        const payload = new URLSearchParams();
        payload.append('amount', parseFloat(amount).toFixed(2).toString());
        payload.append('order_id', orderId);
        payload.append('currency', 'INR');
        payload.append('merchant_id', "4184792");
        payload.append('language', 'EN');
        payload.append('upiPaymentFlag', '');
        payload.append('redirect_url', `https://app.summairsportsclub.org/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);
        payload.append('cancel_url', `https://app.summairsportsclub.org/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);

        // Uncommnet when want to work on local
        // payload.append('redirect_url', `http://192.168.1.31:7000/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);
        // payload.append('cancel_url', `http://192.168.1.31:7000/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);
        // payload.append("billing_name", "Test");
        // payload.append("billing_address", "Test");
        // payload.append("billing_city", "Test");
        // payload.append("billing_name", "Test");
        // payload.append("billing_state", "Test");
        // payload.append("billing_zip", "102938");
        // payload.append("billing_country", "India");
        // payload.append("billing_tel", "9876543210");
        // payload.append("billing_email", "Test@test.com");
        const response = await axios.post(
          `${baseUrl}/ccavRequestHandler`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              memberId,
              memberCode,
              'Content-Type': 'multipart/form-data',
              Accept: 'text/html',
            },
            responseType: 'text',
          }
        );

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = response.data;
        const form = tempDiv.querySelector("form");
        if (form) {
          form.setAttribute("target", "_self");
          document.body.appendChild(form);
          form.submit();
        } else {
          throw new Error("No form found in response");
        }

        setLoading(false);
      } catch (err) {
        console.error("Payment error:", err);
        setError(err);
        setLoading(false);
      }
    };

    validateAndInitiatePayment();
  }, [location]);

  if (loading) {
    return (
      <Container>
        <Loader />
        <Message>Loading...</Message>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Message style={{ color: "red" }}>Error: {error}</Message>
      </Container>
    );
  }

  return (
    <Container>
      <Loader />
      <Message>Redirecting to payment gateway...</Message>
    </Container>
  );
};

export default TestPayment;
